
    import { css } from 'lit-element';
    export default css`:host{--margin:var(--kat-date-range-picker-margin,0 0 0 12px);display:inline-block;position:relative}kat-date-picker{position:static}kat-date-picker+kat-date-picker{margin:var(--margin)}:host(:not([dir=rtl])) kat-date-picker+kat-date-picker kat-calendar{left:0}:host([dir=rtl]) kat-date-picker+kat-date-picker kat-calendar{right:0}`;
  